/**
 * Solicitud de acceso enviada desde la pantalla pública `/signup`.
 *
 * Partner CRM no tiene alta de auto-servicio: el visitante deja la solicitud y
 * alguien con permisos sobre el módulo `users` (Admin, Manager o un rol
 * personalizado con esos permisos) lo invita con un rol desde esta bandeja.
 */
export interface AccessRequest {
  id: number;
  fullname: string;
  companyName: string;
  email: string;
  phone?: string | null;
  message?: string | null;
  status: AccessRequestStatus;
  source: string;
  notes?: string | null;
  notified: boolean;
  createdAt: string;
  updatedAt: string;
}

/** NEW → CONTACTED → CONVERTED | REJECTED. Espejo del CHECK de la tabla. */
export type AccessRequestStatus =
  | 'NEW'
  | 'CONTACTED'
  | 'CONVERTED'
  | 'REJECTED';

export interface AccessRequestStatusUpdate {
  status: AccessRequestStatus;
  notes?: string;
}

export interface AccessRequestFilters {
  status?: AccessRequestStatus;
  page?: number;
  size?: number;
}

/** Etiquetas en español para la tabla y los selectores. */
export const ACCESS_REQUEST_STATUS_LABEL: Record<AccessRequestStatus, string> = {
  NEW: 'Nueva',
  CONTACTED: 'Contactada',
  CONVERTED: 'Convertida',
  REJECTED: 'Rechazada',
};
